




















import Vue from 'vue'
import Component from 'vue-class-component'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'


@Component
class DigitalCurrency8WatchVideoIntroduction extends Vue {
  projectName: string = projectVariables.projectName

  projectVideoIntroductionUrl: string = projectVariables.projectVideoIntroductionUrl

  digitalCurrencySymbolImageIconUrl: string = projectVariables.digitalCurrencySymbolImageIconUrl

  showDialog: boolean = false
}

export default DigitalCurrency8WatchVideoIntroduction
